import React from 'react';
import './Feature.css';

function Feature({ title, description, icon, onClick }) {
    return (
        <div className="feature" onClick={onClick}>
            <div className="feature-icon">{icon}</div>
            <h3>{title}</h3>
            <p>{description}</p>
        </div>
    );
}

export default Feature;